import React, { Component } from 'react'
import axios from 'axios'
import ServerInfo from '../server.json'
import {connect } from 'react-redux'
import '../App.css';

class ForgotPassword extends Component {
    
    constructor(props) {
        super(props)

        this.state = {
            email: '',
            error:'',
            serverAddress: ServerInfo.serverAddress,
        }
    }

    render() {
        return (
            // <div>
            // <HeaderBar history={this.props.history}></HeaderBar>
            <div className='popup'>
                <div className='popup\_inner' style={styles.loginPanel} >
                        <div style={styles.panelHead} >
                            <img src='/images/Logo_AseanRead.png' style={styles.panelLogo} />
                        </div>
                        <button className="x" onClick={this.props.closePopup}>
                        x
                        </button>
                        <p style={{fontSize:"16px", color:"black", margin:'0px', padding:'10px'}}>Enter email to recover password</p>

                        <div style={styles.heading1}>
                            <div>
                                <input type="email" name="email" placeholder="Email / Identification Number" style={styles.inputText} onChange={this.changeHandler} onKeyPress={this.handleKeyPress} />
                            </div>
                            <p style={{margin:'0px', color:'red'}}>{this.renderError()}</p>
                            <div style={{padding:"10px"}}>
                                <button style={styles.button} onClick={() => this.submit()}>Recover Password</button>
                                <div style={{padding:"5px"}}/>
                                <button style={styles.closeBtn} onClick={this.props.closePopup}>Back</button>
                            </div>

                        </div>
                    </div>
            </div>
        )
    }

    handleKeyPress = (event) => {
        if(event.key === 'Enter'){
            this.submit()
        //   console.log('enter press here! ')
        }
      }

    changeHandler = e => {
        this.setState({ [e.target.name]: e.target.value })
    }

    submit()
    {
        console.log(this.state.email)
        console.log(window.location.origin)

        var urlLink = window.location.origin + "/resetpassword"

        if(this.state.email != "")
        {
            var self = this
            var bodyFormData = new FormData();
            bodyFormData.append("username", this.state.email);
            bodyFormData.append("urlLink", urlLink);
        
            axios({
                method: 'post',
                url: this.state.serverAddress+'/user/generateToken',
                //url: 'http://localhost:8080/user/generateToken',
                data: bodyFormData,
                config: {headers: {
                    "Content-Type": "multipart/form-data"}
                    }
            })
            .then(response => {
                console.log('in: ',response.data)
                if(response.data.status == "1") // success
                {
                    this.state.error = ''

                    console.log(response)
                    //self.props.dispatch({ type: "SIGN_IN" }) // how to pass action
                    //after sign in redirect to main page
                    
                    window.location.href = "/requestreset"
                    // window.location.reload()
                }
                else if(response.data.status == "2")
                {
                    this.state.error = 'Account not exist!'
                }
                console.log('out')
            })
            .catch(error => {
                console.log(error)
            })
        }
        else
        {
            // console.log(response)
            // alert('Please insert your email!')
            this.state.error = 'Please insert your email!'
        }
    }

    renderError()
    {
        if(this.state.error != '')
        {
            return(
                <span>{this.state.error}</span>
            )
        }

        else
        {
            return(
            <span></span>
            )
        }
    }

    // gotoPage = (pageLink) =>
    // {
    //     this.props.history.push(pageLink)
    // }
}

const styles = {
    inputText: {
        width: "240px",
        // size:"50",
        // textAlign: "center",
        // margin : "1vmin",
        padding: "12px",
        // borderRadius: "1vmin"
        // border: "none",
        // backgroundColor:"#f9f9f9"
    },

    button: {
        cursor: 'pointer',

        backgroundColor: "#1e7b85",
        border: "none",
        color: "white",
        // margin : "1vmin",
        // marginTop:"2vmin",
        padding: "5px",
        // textAlign: "center",
        // textDecoration: "none",
        // display: "inline-block",
        fontSize: "14px",
        width: "160px",
        height: "40px",
        borderRadius: '4px'
    },

    closeBtn: {
        cursor: 'pointer',

        backgroundColor: "#f47141",
        border: "none",
        color: "white",
        // margin : "1vmin",
        // marginTop:"2vmin",
        padding: "5px",
        // textAlign: "center",
        // textDecoration: "none",
        // display: "inline-block",
        fontSize: "14px",
        width: "100px",
        height: "40px",
        borderRadius: '4px'
    },

    heading1: {
        // backgroundColor: "#527AAE",
        // textAlign: "center",
        padding: "5px",
        fontSize: "14px",
        color: "black",
        // fontFamily: 'Myriad Pro Regular'
    },
    loginPanel: {
        width: "310px",
        // minHeight: "270px",
        backgroundColor: "white",
        border: "solid",
        color: "#1e7b85",
        margin: "0",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
    },
    panelHead: {
        backgroundColor: "#1e7b85",
        textAlign: 'center'
    },
    panelLogo: {
        height: '50px',
    }
}

export default connect(state => state)(ForgotPassword)
